module.exports = __webpack_public_path__ + "static/media/spain.823b139b.jpg";